import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import centralApiAxios from "../../axios/centralApiAxios";
import { CREATE_SETTINGS_NEW_RECORD, GET_SETTINGS_NEW_RECORD} from '../actions';

import {
    createSettingNewRecordSuccess,
    createSettingNewRecordError,
    getSettingNewRecordSuccess,
    getSettingNewRecordError
} from './actions';

const CREATE_NEW_RECORD_ERROR = "New record success.";

const createSettingNewRecordAsync = async (newRecord) => {

  localStorage["recordGAListReturned"] = "";
  try{

    newRecord.userId = newRecord.jsonMetaData.userId;
    newRecord.password = newRecord.jsonMetaData.password;
    newRecord.domain = newRecord.jsonMetaData.domain;
    newRecord.baseUrl = newRecord.jsonMetaData.baseUrl;
    newRecord.handle = newRecord.jsonMetaData.handle;
    newRecord.token = newRecord.jsonMetaData.token;
    newRecord.appName = newRecord.jsonMetaData.appName;
    newRecord.apiKey = newRecord.jsonMetaData.apiKey;

    const responseObject = await centralApiAxios.post("settings", newRecord);

    const recordGAListReturned = await centralApiAxios.get(`${"settings"
        + "?trashed=false"
        + "&search_text="}${+"&pageSize="}${1
        }&pageNumber=${1}`);

      localStorage["recordGAListReturned"] = JSON.stringify(recordGAListReturned);

    return {
    newsItem: responseObject.data,
    settingId: responseObject.data.settingId,
    trashed : newRecord.trashed,
    isNewsItemCreate: !(newRecord.settingId > 0),
    message: ""
    };
  }
  catch (err) {
    // alert(err);
    return {
       message: CREATE_NEW_RECORD_ERROR,
    };
  }
};

function* createSettingNewRecord({ payload }) {
    // const { history } = payload;
    if (payload.isSagaExecuted)
    {
         yield put(createSettingNewRecordError("saga called"));
    }
    else{
        if (!payload.isSagaExecuted)
        {
            payload.isSagaExecuted = true;
        }

      try {
        const resultReturned = yield call(createSettingNewRecordAsync, payload.newRecord);
        if (!resultReturned.message) {
          yield put(createSettingNewRecordSuccess(resultReturned));
          window.location.reload();
        } else {
          yield put(createSettingNewRecordError(resultReturned.message));
        }
      } catch (errorExp) {
        yield put(createSettingNewRecordError(CREATE_NEW_RECORD_ERROR));
      }
    }    
}

const getSettingNewRecordAsync = async (payload) => {

  if (payload.settingid == 0)
  {
    return {
      settingRecord: undefined,
      settingId: 0,
      message: ""
    };
  }
  try{
    const responseObject = await centralApiAxios.get(`/settings/${  payload.settingid}`);
    return {
    settingRecord: responseObject.data,
    settingId: responseObject.data.settingId,
    message: ""
    };
  }
  catch (err) {
    // alert(err);
    return {
       message: CREATE_NEW_RECORD_ERROR,
    };
  }
};

function* getSettingNewRecord({ payload }) {
    // const { history } = payload;
    if (payload.isSagaExecuted)
    {
         yield put(createSettingNewRecordError("saga called"));
    }
    else{
        if (!payload.isSagaExecuted)
        {
            payload.isSagaExecuted = true;
        }
        try {
      const resultReturned = yield call(getSettingNewRecordAsync, payload);
      if (!resultReturned.message) {
        yield put(getSettingNewRecordSuccess(resultReturned));
      } else {
        yield put(getSettingNewRecordError(resultReturned.message));
      }
    } catch (errorExp) {
      yield put(getSettingNewRecordError(CREATE_NEW_RECORD_ERROR));
    }
    }
    
}
// eslint-disable-next-line
export function* watchCreateRecords(newRecord) {
  yield takeEvery(CREATE_SETTINGS_NEW_RECORD, createSettingNewRecord);
}
// eslint-disable-next-line
export function* watchGetSettingNewRecord(newRecord) {
  yield takeEvery(GET_SETTINGS_NEW_RECORD, getSettingNewRecord);
}

export default function* rootSaga() {
    yield all([
        fork(watchGetSettingNewRecord),
        fork(watchCreateRecords)
    ]);
}
